var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量导入",
        visible: _vm.dialogVisible,
        "custom-class": "zyyj-dialog zyyj-d-upload",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.closeDialog
      }
    },
    [
      _c("span", { staticStyle: { "font-size": "14px", color: "#757575" } }, [
        _vm._v(
          "文件上传：1、请严格按照模版格式录入数据；2、导入失败时，请检查Excel中的数据录入"
        )
      ]),
      _vm._v(" "),
      _c(
        "el-upload",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "upload",
          staticClass: "zyyj-d-u-el-upload",
          attrs: {
            drag: "",
            action: _vm.action,
            accept: ".xlsx",
            headers: _vm.myHeaders,
            "show-file-list": false,
            "on-success": _vm.handleUploadSuccess,
            "on-error": _vm.handleUploadError,
            "before-upload": _vm.beforeUpload
          }
        },
        [
          _c("i", { staticClass: "el-icon-upload" }),
          _vm._v(" "),
          _c("div", { staticClass: "el-upload__text" }, [
            _vm._v("\n      将文件拖到此处，或\n      "),
            _c("em", [_vm._v("点击上传")])
          ]),
          _vm._v(" "),
          _vm.uploadResult.code === 422
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v("导入文件格式与模版不匹配，请重新确认")]
              )
            : _vm.uploadResult.code === 204
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v("excel 中无有效数据")]
              )
            : _vm.uploadResult.code === 500
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v("请检查文件大小和格式，或联系管理员")]
              )
            : _vm.uploadResult.code === "template_error"
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v("当前导入文件与模版与不一致，请重新检查后再试！")]
              )
            : _vm.uploadResult.code === 400
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v(_vm._s(_vm.uploadResult.data))]
              )
            : _vm.uploadResult.total >= 0
            ? _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      staticStyle: { "font-size": "14px" },
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _vm._v(
                        "\n        共导入 " +
                          _vm._s(_vm.uploadResult.total) +
                          " " +
                          _vm._s(_vm.topic === "人" ? "人" : "所学校") +
                          "，导入成功\n        "
                      ),
                      _c("span", { staticStyle: { color: "green" } }, [
                        _vm._v(_vm._s(_vm.uploadResult.successNumber))
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.topic === "人" ? "人" : "所") +
                          "，\n        "
                      ),
                      _c("span", [
                        _vm._v(
                          "更新学生" +
                            _vm._s(_vm.uploadResult.updateNumber) +
                            "人，新增学生" +
                            _vm._s(_vm.uploadResult.importNumber) +
                            "人，"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.uploadResult.failRecords.length > 0
                        ? _c("span", [
                            _vm.uploadResult.failNumber
                              ? _c("span", [_vm._v("导入失败")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.uploadResult.failNumber
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(_vm.uploadResult.failNumber) +
                                      _vm._s(_vm.topic === "人" ? "人" : "所") +
                                      "，"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "var(--theme-color)",
                                  cursor: "pointer"
                                },
                                on: { click: _vm.downloadRecord }
                              },
                              [
                                _vm._v(
                                  "\n            点此下载失败记录\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.hasFails
        ? _c(
            "el-row",
            { staticClass: "zyyj-fail-record-row" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.uploadResult.failRecords,
                        size: "medium",
                        border: "",
                        "header-cell-style": { background: "#f9f9f9" }
                      }
                    },
                    [_vm._t("if-failure")],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", disabled: _vm.loading },
              on: { click: _vm.handleDownloadTemplate }
            },
            [_vm._v("下载模板")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.loading, size: "small" },
              on: { click: _vm.closeDialog }
            },
            [_vm._v("关 闭")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-9287928a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9287928a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/school-admin/affair/StudentImporterBox.vue
// module id = null
// module chunks = 